<template>
  <div id="index">
    <div class="banner_box">
      <Banner/>
      <Login class="banner_box_login"/>
      <ebNotice/>
    </div>
    <div class="notice">
      <PurchaseAnnouncement/>
      <UserGuide/>
    </div>
    <ShowPic/>
    <CompanyLogo/>
    <FindPass/>
  </div>
</template>

<script>
import Banner from '@/components/index/Banner';
import Login from '@/components/index/Login';
import PurchaseAnnouncement from '@/components/index/PurchaseAnnouncement';
import UserGuide from '@/components/index/UserGuide';
import ShowPic from '@/components/index/ShowPic';
import CompanyLogo from '@/components/index/CompanyLogo';
import FindPass from '@/components/index/FindPass';
import ebNotice from '@/components/common/eb-notice';
import { aliyun } from '@/services/temporary-service';
export default {
  name: 'Index',
  components: {
    Banner,
    Login,
    PurchaseAnnouncement,
    UserGuide,
    ShowPic,
    CompanyLogo,
    FindPass,
    ebNotice
  },
  data() {
    return {};
  },
  created() {
    this.$root.layout.isShowAside = false;
    this.$root.layout.isLoading = false;
    this.init();
  },
  methods: {
    async init() {
      try {
        await aliyun();
      } catch (error) {}
    }
  }
};
</script>
<style scoped lang="less">
#index {
  -webkit-font-smoothing: auto;
  background-color: #fff;
  padding-bottom: 32px;
  .banner_box {
    height: 653px;
    width: 1366px;
    position: relative;
  }
  .banner_box_login {
    position: absolute;
    right: 70px;
    top: 70px;
    z-index: 2;
  }
  .notice {
    height: 487px;
    padding-top: 107px;
  }
}
</style>
